import type { FC } from "react";
import { useParams } from "react-router-dom";

import { BaseModal } from "../../common-ui/modal/BaseModal";
import { Permission } from "../../services/authentication/utils/authUtils";
import { BookingCancelPanel } from "../../use-cases/manage/cancel/components/BookingCancelPanel";
import { useBasicBooking } from "../graphql/useBasicBooking";
import { PermissionGateModal } from "../home/components/PermissionGateModal";
import { useAppNavigate } from "../hooks/useAppNavigate";
import { PageTitle } from "../routes/PageTitle";
import { ModalLoader } from "./ModalLoader";

export const BookingCancelModal: FC = () => {
  const { pop } = useAppNavigate();
  const { bookingNo: bookingNoString } = useParams<"bookingNo">();
  const bookingNo = Number(bookingNoString);
  const { booking, loading } = useBasicBooking(bookingNo);

  return (
    <PermissionGateModal
      permission={Permission.EditBookings}
      onRequestClose={pop}
    >
      <BaseModal
        aria-label={"Cancel booking"}
        isOpen
        onRequestClose={pop}
        shouldCloseOnOverlayClick
      >
        <PageTitle title={`Cancel ${bookingNo}`} />
        {loading || !booking ? (
          <ModalLoader />
        ) : (
          <BookingCancelPanel
            booking={booking}
            onClose={pop}
            onFail={pop}
            trackerCategory={"Grid"}
          />
        )}
      </BaseModal>
    </PermissionGateModal>
  );
};
